<template>
  <div class="divBox">
    <el-card class="box-card">
      <el-form
        ref="formValidate"
        v-loading="fullscreenLoading"
        class="formValidate mt20"
        label-width="160px"
        v-model="formValidate"
        @submit.native.prevent
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="商品分类：" prop="cate_id">
              <el-cascader
                v-model="formValidate.cate_id"
                class="selWidth"
                :options="categoryList"
                :props="props"
                filterable
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="品牌：" prop="brand_id">
              <el-cascader
                v-model="formValidate.brand_id"
                class="selWidth"
                :options="brandList"
                :props="props"
                filterable
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="是否上架：" prop="is_show">
              <el-select
                v-model="formValidate.is_show"
                placeholder="请选择"
                class="filter-item selWidth"
                clearable
              >
                <el-option label="上架" value="1"/>
                <el-option label="下架" value="0"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="排序：" prop="sort">
              <el-input-number :min=0 v-model="formValidate.sort"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="链接：" prop="originContent">
              <el-input  v-model="formValidate.originContent"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="店铺类型：" prop="platType">
              <el-select
                v-model="formValidate.platType"
                clearable
                filterable
                placeholder="请选择"
                class="selWidth"
              >
                <el-option
                  v-for="(key,item) in platTypeList"
                  :key="item"
                  :label="key"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="封面图：" prop="mainPic">
              <div
                class="upLoadPicBox"
                title="750*750px"
                @click="modalPicTap('1')"
              >
                <div v-if="formValidate.mainPic" class="pictrue">
                  <img :src="formValidate.mainPic">
                </div>
                <div v-else class="upLoad">
                  <i class="el-icon-camera cameraIconfont" />
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="轮播：" prop="images">
              <div class="acea-row">
                <div
                  v-for="(item, index) in formValidate.images"
                  :key="index"
                  class="pictrue"
                  draggable="false"
                  @dragstart="handleDragStart($event, item)"
                  @dragover.prevent="handleDragOver($event, item)"
                  @dragenter="handleDragEnter($event, item)"
                  @dragend="handleDragEnd($event, item)"
                >
                  <img :src="item">
                  <i
                    class="el-icon-error btndel"
                    @click="handleRemove(index)"
                  />
                </div>
                <div
                  v-if="formValidate.images.length < 10"
                  class="uploadCont"
                  title="750*750px"
                >
                  <div class="upLoadPicBox" @click="modalPicTap('2')">
                    <div class="upLoad">
                      <i class="el-icon-camera cameraIconfont" />
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="售卖价格：" prop="actualPrice">
              <el-input  v-model="formValidate.actualPrice"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="原价：" prop="originalPrice">
              <el-input  v-model="formValidate.originalPrice"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="销量：" prop="monthSales">
              <el-input  v-model="formValidate.monthSales"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="标题：" prop="title">
              <el-input  v-model="formValidate.title"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="详情：" prop="detailPics">
              <ueditor-from v-model="formValidate.detailPics" :content="formValidate.detailPics" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item style="margin-top:30px;">
          <el-button :loading="loading" type="primary" class="submission" size="small" @click="handleSubmit()">提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import { roterPre } from '@/settings'
import {
  brandSearchListApi,
  categoryListApi,
  platTypeSelectListApi,
  productOutreachDetailApi,
  saveOutreachDataApi, updateOutreachProductApi
} from "@/api/product";
import ueditorFrom from "@/components/ueditorFrom";
const defaultObj = {
  cate_id: '',
  brand_id: '',
  is_show: '0',
  sort:0,
  originContent:'',
  mainPic:'',
  actualPrice: 0,
  originalPrice: 0,
  title: '',
  platType: '',
  monthSales: 0,
  images: '',
  detailPics:''


}
export default {
  name: 'OutreachProductInfo',
  components: {
    ueditorFrom,
  },
  data() {
    return {
      roterPre: roterPre,
      fullscreenLoading: false,
      formValidate: Object.assign({}, defaultObj),
      loading: false,
      grid2: {
        xl: 10,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      grid: {
        xl: 8,
        lg: 8,
        md: 12,
        sm: 24,
        xs: 24
      },
      storeTypeMap: {},
      progress: 0,
      categoryList: [],
      data: [],
      props: { emitPath: false },
      brandList:[],
      platTypeList:[]
    }
  },
  mounted() {
    this.getCategoryList()
    this.getBrandList()
    this.getProductOutreachData()
    this.getPlatTypeList()
  },
  methods: {
    // 移动
    handleDragStart(e, item) {
      this.dragging = item;
    },
    handleDragEnd(e, item) {
      this.dragging = null;
    },
    handleDragOver(e) {
      e.dataTransfer.dropEffect = "move";
    },
    handleDragEnter(e, item) {
      e.dataTransfer.effectAllowed = "move";
      if (item === this.dragging) {
        return;
      }
      const newItems = [...this.formValidate.images];
      const src = newItems.indexOf(this.dragging);
      const dst = newItems.indexOf(item);
      newItems.splice(dst, 0, ...newItems.splice(src, 1));
      this.formValidate.images = newItems;
    },
    handleRemove(i) {
      this.formValidate.images.splice(i, 1);
    },
    // 点击图
    modalPicTap(tit, num, i) {
      const _this = this;
      const attr = [];
      this.$modalUpload(function(img) {
        if (tit === "1" && !num) {
          _this.formValidate.mainPic = img[0];
        }
        if (tit === "2" && !num) {
          img.map(item => {
            _this.formValidate.images.push(item);
            if (_this.formValidate.images.length > 10) {
              _this.formValidate.images.length = 10;
            }
          });
        }
      }, tit);
    },
    // 平台分类
    getCategoryList() {
      categoryListApi()
        .then(res => {
          this.categoryList = res.data
        })
        .catch(res => {
          this.$message.error(res.message)
        })
    },
    getPlatTypeList() {
      platTypeSelectListApi()
        .then(res => {
          this.platTypeList = res.data
        })
        .catch(res => {
          this.$message.error(res.message)
        })
    },
    getBrandList() {
      brandSearchListApi()
        .then(res => {
          this.brandList = res.data
        })
        .catch(res => {
          this.$message.error(res.message)
        })
    },
    getProductOutreachData()
    {
      this.fullscreenLoading = true
      productOutreachDetailApi(this.$route.params.id)
        .then(res => {
          this.fullscreenLoading = false
          this.loading = false
          if (res.data) {
            this.formValidate = res.data
            this.formValidate.is_show = this.formValidate.is_show.toString()
            console.log(this.formValidate.detailPics)
          }
        })
        .catch(res => {
          this.fullscreenLoading = false
          this.$message.error(res.message)
        })
    },
    // 提交
    handleSubmit() {
      if (!this.formValidate.cate_id) {
        this.$message.error('请选择分类')
        return false
      }
      if (!this.formValidate.brand_id) {
        this.$message.error('请选择品牌')
        return false
      }
      if (!this.formValidate.is_show) {
        this.$message.error('请选择状态')
        return false
      }
      if (!this.formValidate.originContent) {
        this.$message.error('请输入链接')
        return false
      }
      if (!this.formValidate.platType) {
        this.$message.error('请选择店铺类型')
        return false
      }
      if (!this.formValidate.mainPic) {
        this.$message.error('请上传商品封面图')
        return false
      }
      if (!this.formValidate.title) {
        this.$message.error('请填写标题')
        return false
      }
      if (!this.formValidate.actualPrice) {
        this.$message.error('请填写售卖价格')
        return false
      }
      this.formValidate.outreach_store_id = this.$route.params.id
      updateOutreachProductApi(this.formValidate)
        .then(res => {
          this.fullscreenLoading = false
          this.$message.success(res.message)
          this.$router.push({ path: this.roterPre + '/product/outreach' })
          this.loading = false
        })
        .catch(res => {
          this.fullscreenLoading = false
          this.loading = false
          this.$message.error(res.message)
        })
    }
  }
}
</script>
<style scoped lang="scss">
.label_tip{
  display: inline-block;
  margin-left: 20px;
  color: #C0C4CC;
}
.selWidth {
  width: 100%;
}
.selWidthd {
  width: 300px;
}
.dialog-scustom,.addDia{
  min-width: 400px;
  height: 900px;
  .el-dialog{
    width: 400px;
  }
  h3{
    color: #333;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    margin: 0;
  }
}
.pictrue {
  width: 60px;
  height: 60px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  margin-right: 10px;
  position: relative;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
}
.agreement{
  width: 350px;
  margin: 0 auto;
  box-shadow: 1px 5px 5px 2px rgba(0,0,0,.2);
  padding: 26px;
  border-radius: 15px;
  .content{
    height: 600px;
    overflow-y:scroll;
    /deep/ p{
      font-size: 13px;
      line-height: 22px;
    }
  }
  /deep/ img{
    max-width: 100%;
  }
  p{
    text-align: justify;
  }
}
/*css主要部分的样式*/
/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 10px; /*对垂直流动条有效*/
  height: 10px; /*对水平流动条有效*/
}
/*定义滚动条的轨道颜色、内阴影及圆角*/
::-webkit-scrollbar-track{
  /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);*/
  background-color: transparent;
  border-radius: 3px;
}
.iview-video-style {
  width: 40%;
  height: 180px;
  border-radius: 10px;
  background-color: #707070;
  margin-top: 10px;
  position: relative;
  overflow: hidden;
}
.iconv {
  color: #fff;
  line-height: 180px;
  display: inherit;
  font-size: 26px;
  position: absolute;
  top: -74px;
  left: 50%;
  margin-left: -25px;
}
.iview-video-style .mark {
  position: absolute;
  width: 100%;
  height: 30px;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  text-align: center;
}
.uploadVideo {
  margin-left: 10px;
}
.perW50 {
  width: 50%;
}
.submission {
  margin-left: 10px;
}
.btndel {
  position: absolute;
  z-index: 1;
  width: 20px !important;
  height: 20px !important;
  left: 46px;
  top: -4px;
}
.pictrue {
  width: 60px;
  height: 60px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  margin-right: 10px;
  position: relative;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
}

</style>
